import * as React from 'react';
import { CredentialProvidersEnum } from '@ghq-abi/auth-client-lib';
import { signIn } from '@ghq-abi/auth-client-lib/client';
import { Flex, Typography } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { useSessionInfo } from '~/core/contexts/SessionInfoContext';
import { getBasePath } from '~/shared/utils/base-path.util';

type AuthGuardProps = {
  children: React.ReactNode;
};

export function AuthGuard({ children }: AuthGuardProps) {
  const { sessionInfo } = useSessionInfo();
  const { t } = useTranslate('web-app');
  const hasTriggeredSignIn = React.useRef(false);

  const userInfo = sessionInfo?.proxiedAs || sessionInfo;

  React.useEffect(() => {
    if (!userInfo?.globalId && !hasTriggeredSignIn.current) {
      hasTriggeredSignIn.current = true;
      void signIn(CredentialProvidersEnum.AZURE_AD, {
        callbackUrl: getBasePath() || '/'
      });
    }
  }, [userInfo?.globalId]);

  if (!userInfo?.globalId) {
    return (
      <Flex
        direction="column"
        align="center"
        justify="center"
        className="h-screen">
        <Typography variant="body-md-regular" color="light">
          {t('auth.redirecting-to-sign-in', 'Redirecting to sign in...')}
        </Typography>
      </Flex>
    );
  }

  return <>{children}</>;
}
